import { ELogLevel } from "apps/idl/src/modules/logger/models/ELogLevel";

/** Configuration du service de logging */
export interface ILoggerConfig {
	/** Id de la base de donnée de logging */
	databaseId: string,
	/** Niveaux de log à intercepter : debug, log, warn, error */
	levels: ELogLevel[]
}